import React from 'react';

const TfnContext = React.createContext();

export { TfnContext as default };
